import React from 'react';

import { lang, remCss } from 'src/helpers';
import { MCButton } from '../basic';

export const ButtonFooter = React.memo(
  ({
    hide,
    cancelButton,
    actionButton,
    setLoading,
    loading,
    body,
    dataForm,
    setDataForm,
    noBodyBorder = false,
    screenDetail
  }) =>
    (!!cancelButton || !!actionButton) && (
      <div
        className={
          'mc-modal-footer mc-flex-25 ' +
          (body ? '' : 'mc-b-none') +
          (noBodyBorder ? ' mc-b-none' : '')
        }
        style={{
          ...(screenDetail.isMediumScreen
            ? {
                padding: `${remCss(30)}px ${remCss(60)}px ${remCss(60)}px ${remCss(60)}px`,
                gap: remCss(60)
              }
            : {})
        }}
      >
        {cancelButton && (
          <MCButton
            flex
            large={!screenDetail.isLargeScreen}
            style={{
              ...(!screenDetail.isLargeScreen ? { height: remCss(65) } : {})
            }}
            primary
            radius
            light
            type={'button'}
            label={cancelButton.label}
            onClick={() =>
              cancelButton.action({
                hide,
                setLoading,
                dataForm,
                setDataForm
              })
            }
            disabled={loading}
          />
        )}
        {actionButton && (
          <MCButton
            flex
            large={!screenDetail.isLargeScreen}
            style={{
              ...(!screenDetail.isLargeScreen ? { height: remCss(65) } : {})
            }}
            primary
            radius
            dark
            type={'button'}
            loading={loading}
            label={
              loading && actionButton.loadingLabel
                ? lang.t(actionButton.loadingLabel) + '...'
                : lang.t(actionButton.label)
            }
            onClick={() =>
              actionButton.action({
                hide,
                setLoading,
                dataForm,
                setDataForm
              })
            }
            disabled={loading}
          />
        )}
      </div>
    )
);
ButtonFooter.displayName = 'ButtonFooter';
